import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import TermsContainer from 'containers/TermsContainer';

const ManualPage = () => {
  const title = {
    ko: '예약정보 작성',
    en: 'Reservation Information',
    ja: '予約情報',
    zh: '预订信息',
  };
  return (
    <PageLayout title="예약정보 작성">
      <TermsContainer type="RESERVATION" title={title} />
    </PageLayout>
  );
};

export default ManualPage;
